<template>
    <ul class="social-copyright flex items-center gap-4">
        <li>
            <a href="https://www.twitter.com/" target="_blank" @mouseenter="hoveredIcon = 1" @mouseleave="hoveredIcon = null">
                <img :src="hoveredIcon === 1 ? require('@/assets/images/icons/组 795.png') : require('@/assets/images/icons/组件 56.png')" alt="">
            </a>
        </li>
        <li>
            <a href="https://www.facebook.com/" target="_blank" @mouseenter="hoveredIcon = 2" @mouseleave="hoveredIcon = null">
                <img :src="hoveredIcon === 2 ? require('@/assets/images/icons/组 796.png') : require('@/assets/images/icons/组件 57.png')" alt="">
            </a>
        </li>
        <li>
            <a href="https://www.linkedin.com/" target="_blank" @mouseenter="hoveredIcon = 3" @mouseleave="hoveredIcon = null">
                <img :src="hoveredIcon === 3 ? require('@/assets/images/icons/组 797.png') : require('@/assets/images/icons/组件 58.png')" alt="">
            </a>
        </li>
        <li>
            <a href="https://www.instagram.com/" target="_blank" @mouseenter="hoveredIcon = 4" @mouseleave="hoveredIcon = null">
                <img :src="hoveredIcon === 4 ? require('@/assets/images/icons/组 798.png') : require('@/assets/images/icons/组件 59.png')" alt="">
            </a>
        </li>
        <li>
            <a href="https://www.gmail.com/" target="_blank" @mouseenter="hoveredIcon = 5" @mouseleave="hoveredIcon = null">
                <img :src="hoveredIcon === 5 ? require('@/assets/images/icons/组 799.png') : require('@/assets/images/icons/组件 60.png')" alt="">
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'SocialLinks',
        data() {
            return {
                hoveredIcon: null
            }
        }
    }
</script>

<style scoped>
.social-copyright li a img {
    transition: transform 0.3s ease;
}

.social-copyright li a:hover img {
    transform: scale(1.1);
}
</style>
